import { Bookmark, CheckSquare, Bug, Zap, ListTree, GitPullRequestArrow, Flag, ChevronsUp, ChevronUp, Minus, ChevronDown, ChevronsDown } from "lucide-react";

export const TYPE_META = {
  EPIC: { icon: Zap, color: "text-[#7C3AED] bg-[#EDE9FE] border-[#DDD6FE]" },
  STORY: { icon: Bookmark, color: "text-[#166534] bg-[#DCFCE7] border-[#BBF7D0]" },
  TASK: { icon: CheckSquare, color: "text-[#1E3A8A] bg-[#DBEAFE] border-[#BFDBFE]" },
  SUBTASK: { icon: ListTree, color: "text-[#0F766E] bg-[#CCFBF1] border-[#99F6E4]" },
  BUG: { icon: Bug, color: "text-[#991B1B] bg-[#FEE2E2] border-[#FECACA]" },
  CHANGE: { icon: GitPullRequestArrow, color: "text-[#9A3412] bg-[#FFEDD5] border-[#FED7AA]" },
  ACTION: { icon: Flag, color: "text-[#334155] bg-[#F1F5F9] border-[#E2E8F0]" },
};

export const PRIORITY_META = {
  HIGHEST: { icon: ChevronsUp, color: "text-[#991B1B]" },
  HIGH: { icon: ChevronUp, color: "text-[#C2410C]" },
  MEDIUM: { icon: Minus, color: "text-[#A16207]" },
  LOW: { icon: ChevronDown, color: "text-[#1E3A8A]" },
  LOWEST: { icon: ChevronsDown, color: "text-[#64748B]" },
};

export const CATEGORY_STYLE = {
  TODO: "text-[#334155] bg-[#F1F5F9] border-[#E2E8F0]",
  IN_PROGRESS: "text-[#1E3A8A] bg-[#DBEAFE] border-[#BFDBFE]",
  DONE: "text-[#166534] bg-[#DCFCE7] border-[#BBF7D0]",
};

export function TypeIcon({ type, className = "h-3.5 w-3.5" }) {
  const meta = TYPE_META[type] || TYPE_META.TASK;
  const Icon = meta.icon;
  return <span className={`inline-flex items-center justify-center rounded border p-0.5 ${meta.color}`} title={type}><Icon className={className} /></span>;
}

export function PriorityIcon({ priority, className = "h-3.5 w-3.5" }) {
  const meta = PRIORITY_META[priority] || PRIORITY_META.MEDIUM;
  const Icon = meta.icon;
  return <Icon className={`${className} ${meta.color}`} title={priority} />;
}

export function Avatar({ name, size = "h-6 w-6 text-[10px]" }) {
  if (!name) return <span className={`${size} rounded-full border border-dashed border-border inline-flex items-center justify-center text-muted-foreground`}>?</span>;
  const initials = name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
  return <span className={`${size} rounded-full bg-[#1E3A8A] text-white inline-flex items-center justify-center font-semibold`} title={name}>{initials}</span>;
}

export function StatusPill({ name, category }) {
  return <span className={`text-[10px] font-semibold border rounded px-1.5 py-0.5 whitespace-nowrap ${CATEGORY_STYLE[category] || CATEGORY_STYLE.TODO}`}>{name}</span>;
}

export const fmtAgo = (iso) => {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
};
